import { Form } from "react-bootstrap"

export default function FastTextArea(props) {
    let totalCharacters = props.text ? props.text.length : 0
    let defaultMaxLength = 1024
    let defaultRows = 5

    const onTextAreaChanged = (event) => {
        props.callback(event)
    }

    const getFontColorClass = () => {
        if (totalCharacters == props.maxLength || totalCharacters == defaultMaxLength) {
            return "text-end small text-danger"
        } else {
            return "text-end small"
        }
    }

    return (
        <div className="mb-3">
            <Form.Control
                name={props.id}
                as="textarea"
                className="form-textarea preserve-linebreaks"
                onChange={onTextAreaChanged}
                value={props.text}
                maxLength={props.maxLength || defaultMaxLength}
                rows={props.rows || defaultRows}
                disabled={props.disabled}
                >
            </Form.Control>
            <div className={getFontColorClass()}>
                {totalCharacters}/{props.maxLength || defaultMaxLength} Characters
            </div>
        </div>
    )
}